// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__1GeYK","footer":"ModalFilter_footer__14GLG"};